import { message, PageHeader, Popconfirm, Spin } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
    TableItem,
    ButtonItem,
    dineroDisabledMask,
} from "../../../../Components/Items";
import {
    columnasBase,
    columnaMargenReal,
    descargarLibroPrecios,
} from "../plantillaPreciosExcel";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import ModalProgreso from "../../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../../Components/seguirProcesoMasivo";

class AnalizarDiferenciasPrecios extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        archivosExcel: [],
        data: [],
        archivoError: null,
        listaDePrecios: [],
        preciosEmpresa: [],
        agregarColumnas: [],
        actualizando: false,
        progreso: { procesados: 0, total: null },
    }

    componentDidMount() {
        this.consultarAnalisis()

        // El trabajo corre en el servidor y avisa por WebSocket: se escribe por
        // lotes y con pausas para no saturar la base, así que puede tardar.
        this.seguidor = new SeguidorProcesoMasivo({
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            onProgreso: (progreso) => this.setState({ actualizando: true, progreso }),
            onFin: (resumen) => {
                this.setState({ actualizando: false, progreso: { procesados: 0, total: null } })
                // Sin resumen el proceso terminó pero no dejó números (murió, o
                // caducó su resultado): se cierra sin anunciar cifras inventadas.
                if (resumen) {
                    message.success(
                        "Los precios se han actualizado correctamente de " +
                        (resumen.numeroInsumosActualizados ?? 0) + " insumos."
                    )
                }
                this.consultarAnalisis()
            },
            onError: (error) => {
                this.setState({ actualizando: false, progreso: { procesados: 0, total: null } })
                message.error(error || "Sucedio un error y no se pudieron actualizar los precios.")
                this.consultarAnalisis()
            },
        })
        this.seguidor.escuchar()

        // Si el usuario recargó la pantalla a media corrida, el estado local
        // arranca en blanco y el modal no aparecería.
        this.seguidor.consultarEnCurso().then((enCurso) => {
            if (enCurso) this.setState({ actualizando: true, progreso: enCurso })
        })
    }

    componentWillUnmount() {
        if (this.seguidor) this.seguidor.detener()
    }

    consultarAnalisis() {
        this.setState({ loading: true })
        axios
            .post(
                "insumos/selectListasDePreciosAD",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    this.setState({
                        listaDePrecios: res.data.listaDePrecios,
                        preciosEmpresa: res.data.preciosEmpresa,
                        agregarColumnas: res.data.preciosEmpresa.flatMap((precio) => {
                            return [
                                {
                                    title: `%F ${precio.nombre}`,
                                    dataIndex: `precio_pf${precio._id}`,
                                    key: `precio_pf${precio._id}`,
                                    render: (text) => {
                                        if (text) return text + '%'
                                        return '-'
                                    },
                                    sorter: (a, b) => {
                                        const valA = a[`precio_pf${precio._id}`] ?? 0;
                                        const valB = b[`precio_pf${precio._id}`] ?? 0;

                                        if (valA < valB) return -1;
                                        if (valA > valB) return 1;
                                        return 0;
                                    },
                                },
                                {
                                    title: `%R ${precio.nombre}`,
                                    dataIndex: `precio_pr${precio._id}`,
                                    key: `precio_pr${precio._id}`,
                                    render: (text) => {
                                        if (text) return text + '%'
                                        return '-'
                                    },
                                    sorter: (a, b) => {
                                        const valA = a[`precio_pr${precio._id}`] ?? 0;
                                        const valB = b[`precio_pr${precio._id}`] ?? 0;

                                        if (valA < valB) return -1;
                                        if (valA > valB) return 1;
                                        return 0;
                                    },
                                },
                                {
                                    title: `Precio ${precio.nombre}`,
                                    dataIndex: `precio_${precio._id}`,
                                    key: `precio_${precio._id}`,
                                    render: (text) => {
                                        if (text) return dineroDisabledMask(text)
                                        return '-'
                                    },
                                    sorter: (a, b) => {
                                        const valA = a[`precio_${precio._id}`] ?? 0;
                                        const valB = b[`precio_${precio._id}`] ?? 0;

                                        if (valA < valB) return -1;
                                        if (valA > valB) return 1;
                                        return 0;
                                    },
                                }
                            ]
                        }),
                    })
                } else {
                    this.setState({ listaDePrecios: [] });
                }
            });

    }

    descargarDiferenciasPrecios() {
        let datosDescargar = []
        datosDescargar = this.state.listaDePrecios.map((valueInsumo) => {

            let agregarPPrecios = {}

            if (valueInsumo.precios && valueInsumo.precios.length > 0) {
                valueInsumo.precios.forEach((valuePrecio) => {

                    const precioEmpresa = this.state.preciosEmpresa.find((precio) => precio._id.toString() === valuePrecio.precioId.toString())

                    if (!precioEmpresa) return

                    agregarPPrecios = {
                        ...agregarPPrecios,
                        [`%R ${precioEmpresa.nombre}`]: valuePrecio.porcentaje,
                        [`%F ${precioEmpresa.nombre}`]: valuePrecio.porcentajeFijo,
                        [`Precio ${precioEmpresa.nombre}`]: valuePrecio.precio,
                        [`Precio Nuevo ${precioEmpresa.nombre}`]: valuePrecio.precioNuevo,
                        // %R y %F son los margenes capturados; este es el que el
                        // precio vigente deja contra el ultimo costo de compra.
                        ...columnaMargenReal(valueInsumo, precioEmpresa),
                    }
                })
            }

            return {
                ...columnasBase(valueInsumo),
                ...agregarPPrecios,
            };
        });
        descargarLibroPrecios(
            [{ nombre: "Analisis_Diferencias_Precios", filas: datosDescargar }],
            `Analisis_Diferencias_Precios_${moment().format("YYYY-MM-DD")}`
        );
    }

    actualizarPrecios() {
        this.setState({ loading: true });
        axios
            .post(
                "insumos/actualizarPrecios",
                { empresaId: this.props.empresaId, numeroInsumos: this.state.listaDePrecios.length },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    // Rechazos que sí llegan por HTTP: la lista cambió, o ya hay
                    // otra operación masiva en curso para esta empresa.
                    message.error(res.data.message || "Sucedio un error y no se pudieron actualizar los precios.");
                    this.consultarAnalisis();
                    return;
                }
                // Arrancó. El resto (avance y cierre) llega por el seguidor.
                this.seguidor.seguir(res.data.procesoId);
                this.setState({
                    actualizando: true,
                    progreso: { procesados: 0, total: res.data.total ?? null },
                });
            });
    }

    atras() {
        this.props.history.goBack();
    }


    render() {
        const columns = [
            {
                title: "Clave",
                dataIndex: "clave",
                key: "clave",
                sorter: (a, b) => {
                    if (a.clave < b.clave) {
                        return -1;
                    }
                    if (a.clave > b.clave) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "clave",
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                sorter: (a, b) => {
                    if (a.descripcion < b.descripcion) {
                        return -1;
                    }
                    if (a.descripcion > b.descripcion) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "descripcion",
            },
            {
                title: "Unidad",
                dataIndex: "unidad",
                key: "unidad",
                sorter: (a, b) => {
                    if (a.unidad < b.unidad) {
                        return -1;
                    }
                    if (a.unidad > b.unidad) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "unidad",
            },
            ...this.state.agregarColumnas,
        ];
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={"Analizar Diferencias de Precios"}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={[
                        <Popconfirm
                            title={
                                <div style={{ maxWidth: 340 }}>
                                    <p style={{ marginBottom: 8, fontWeight: 600 }}>
                                        ⚠️ Verifica los precios nuevos en el Excel
                                    </p>
                                    <p style={{ marginBottom: 8 }}>
                                        Antes de continuar, asegúrate de que los <strong>precios nuevos</strong> estén correctos en el archivo de Excel.
                                    </p>
                                </div>
                            }
                            onConfirm={() => this.actualizarPrecios()}
                            okText="Sí"
                            cancelText="No"
                        >
                            <ButtonItem type="primary" disabled={this.state.loading} verde>Actualizar</ButtonItem>
                        </Popconfirm>,
                        <ButtonItem onClick={() => this.descargarDiferenciasPrecios()} disabled={this.state.loading} icon={<DownloadOutlined />} type="primary" blanco>Descargar</ButtonItem>
                    ]}
                />
                <Spin spinning={this.state.loading}>
                    <TableItem size='small' dataSource={this.state.listaDePrecios} columns={columns} />
                </Spin>
                <ModalProgreso
                    visible={this.state.actualizando}
                    titulo="Actualizando precios"
                    descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Los precios se escriben por lotes para no saturar la base."
                    procesados={this.state.progreso.procesados}
                    total={this.state.progreso.total}
                    unidad="insumos"
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AnalizarDiferenciasPrecios);
